module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=MT - Malta.ef7d8ff2.svg";